import { apiUrl } from "@/lib/client-environment";

export const GLOBE_VIEW_CONFIG = {
  data: {
    boundarySourcePath: "src/lib/data/geo-data/geoBoundariesCGAZ_ADM0.geojson",
    lowResolutionBoundaryPath: "src/lib/data/geo-data/geoBoundariesCGAZ_ADM0.lowres.json",
    boundaryApiPath: apiUrl("/api/geo-data/country-boundaries"),
    simplificationToleranceDegrees: 0.18,
  },
  globe: {
    earthRadius: 18,
    earthSegments: 128,
    markerRadiusOffset: -0.16,
    atmosphereScale: 1.025,
    atmosphereAlpha: 0.1,
    rotationSpeed: 0.00018,
    atmosphereRotationSpeed: -0.00008,
    gridAlpha: {
      latitude: 0.16,
      longitude: 0.12,
    },
  },
  camera: {
    alpha: -1.46,
    beta: 1.32,
    radius: 1,
    fov: 1,
    lowerRadiusLimit: 0.75,
    upperRadiusLimit: 15.5,
    targetMaxDistanceFromOrigin: 7.8,
    positionMaxDistanceFromOrigin: 16.5,
    wheelPrecision: 38,
    pinchPrecision: 105,
    inertia: 0.82,
    angularSensibilityX: 650,
    angularSensibilityY: 650,
    urlUpdateIntervalMs: 450,
    urlPrecision: 3,
  },
  cameraFlight: {
    durationMs: 1250,
    targetRadiusRatio: 0.91,
    radius: 1.45,
    minBeta: 0.22,
    maxBetaOffset: 0.22,
  },
  boundaries: {
    surfaceOffset: -0.055,
    coreSurfaceOffset: -0.035,
    haloSurfaceOffset: -0.085,
    coreAlpha: 0.94,
    haloAlpha: 0.38,
    coreColor: [0.34, 0.92, 1] as [number, number, number],
    haloColor: [0.05, 0.46, 1] as [number, number, number],
    emissiveColor: [0.16, 0.82, 1] as [number, number, number],
    glowLayerIntensity: 0,
    glowLayerBlurKernelSize: 48,
  },
} as const;

export type GlobeViewConfig = typeof GLOBE_VIEW_CONFIG;
